export const ROUTES = {
  HOME: '/',
  SIGN_IN: '/sign-in',
  SIGN_UP: '/sign-up',
  EVENTS: '/events',
  CONSTITUENCY_WISE_RESULT: '/constituency-wise-results',
  CONSTITUENCY_WISE_REPORT:
    '/constituency-wise-results/constituency-wise-report',
  CENTER_WISE_RESULT: `/center-wise-results/:constituencyId`,
};
